import { NgModule } from '@angular/core';

import { TypeCheckingIsTypePipe } from './type-checking-is-type.pipe';

@NgModule({
  declarations: [TypeCheckingIsTypePipe],
  exports: [TypeCheckingIsTypePipe],
})
export class TypeCheckingPipesModule {}
